import { Platform } from 'react-native';

/**
 * Helper to properly append file to FormData for both web and native platforms
 * @param formData - The FormData object to append to
 * @param fieldName - The field name (e.g., 'image', 'file')
 * @param uri - The file URI (blob URL on web, file:// on native)
 * @param filename - The filename
 * @param mimeType - The MIME type (e.g., 'image/jpeg', 'application/pdf')
 */
export async function appendFileToFormData(
  formData: FormData,
  fieldName: string,
  uri: string,
  filename: string,
  mimeType: string
): Promise<void> {
  if (Platform.OS === 'web') {
    // On web, fetch the blob and create a File object
    const response = await fetch(uri);
    const blob = await response.blob();
    const file = new File([blob], filename, { type: mimeType });
    formData.append(fieldName, file);
  } else {
    // On React Native (iOS/Android), use the native format
    formData.append(fieldName, {
      uri,
      name: filename,
      type: mimeType,
    } as any);
  }
}
